/*
 *   File : transaction-modal.js
 *   Author : https://evoqins.com
 *   Description : transaction modal component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import Icon from "../icons";
import { PrimaryButton } from "../Buttons";
import { EmptyScreen } from "../Other";

/* ---------- Overlay Component ---------- */
const ModalOverlay = ({ onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"
      style={{ zIndex: 1040 }}
      onClick={onClose}
    />
  );
};

/* ---------- Modal Component ---------- */
export default function TransactionModal({ open = false, onClose, data }) {
  if (!open) return null;

  return createPortal(
    <>
      {/* Overlay */}
      <ModalOverlay onClose={onClose} />

      {/* Modal Box */}
      <div
        className="position-fixed overflow-hidden top-50 start-50 translate-middle e-modal-portal rounded-28 shadow p-0 bg-white"
        style={{
          zIndex: 1055,
          width: "500px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-24">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="fw-600 fs-20 m-0">Transaction status</h3>

            <PrimaryButton
              icon={"close"}
              ClassName="bg-transparent p-0"
              size="16"
              onPress={onClose}
            />
          </div>

          {/* Timeline */}
          <div className="d-flex flex-column gap-3">
            {/* Timeline */}
            <div className="d-flex flex-column gap-3">
              {data && data.length > 0 ? (
                data.map((step, index) => (
                  <div key={index} className="d-flex gap-3 align-items-start">
                    {/* Icon + dotted line */}
                    <div
                      className="position-relative"
                      style={{ width: "24px" }}
                    >
                      <div className="text-black">
                        <Icon icon="check-mark" size={20} />
                      </div>

                      {/* Dotted line */}
                      {index !== data.length - 1 && (
                        <div
                          style={{
                            position: "absolute",
                            top: "22px",
                            left: "9px",
                            height: "38px",
                            borderLeft: "2px dotted #8C8C8C",
                          }}
                        />
                      )}
                    </div>

                    {/* Text */}
                    <div>
                      <div className="fw-500 fs-16">{step.label}</div>
                      <div className="d-flex column-gap-2">
                        <div className="fs-14 text-muted">{step.value}</div>
                        <div className="fs-14 text-muted">, {step.status}</div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <EmptyScreen message={'No Transactions to view'}/>
              )}
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
}
